import Vue from 'vue'; // 确保导入Vue
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

// 只在客户端使用Element UI
if (process.client) {
  Vue.use(ElementUI);
}